import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import BuoyIcon from "@mui/icons-material/Navigation";
import CircleIcon from "@mui/icons-material/Circle";
import { Marker } from "react-map-gl";
import {
    sizePeriod,
    cardinalToDegrees,
    colorFt,
    colorWspd,
    windOpacity,
    swellOpacity,
    parseDegrees,
    waterTempOpacity,
    sizeGust,
    colorTemp,
    colorPressure,
    colorPressureTendency,
    visibilityColor,
    colorSalinity,
} from "../Utils/Convert";
let count = 0;

const useStyles = makeStyles({
    iconStyle: {
        minWidth: (props) => props.width,
        minHeight: (props) => props.height,
    },
});

function BuoyMarker(props) {
    const { buoyData, onClick, mapMode, replayEnabled, replayTime, findClosestDataPoint } = props;
    // console.log({ buoyData });
    const buoyIndex = props.buoyIndex;

    // Use time-based lookup in replay mode, otherwise use index
    const buoy = replayEnabled && replayTime && findClosestDataPoint
        ? findClosestDataPoint(buoyData, replayTime)
        : buoyData.slice(-buoyIndex)[0];

    const prevBuoy = buoyData.slice(-(buoyIndex + 1))[0];
    const [longitude, latitude] = buoy?.coords?.coordinates;

    let width;
    let height;
    let angle = 180;
    let value;
    let color1, color2;
    let opacity = 1;
    let useCircle = false;
    if (mapMode === "swell") {
        const size = sizePeriod(buoy.period);
        width = height = size;
        angle = cardinalToDegrees(buoy.swellDir);
        color1 = colorFt(buoy.height);
        color2 = colorFt(prevBuoy.height);
        opacity = swellOpacity(buoy.height);
        // If no swellDir, use circle instead of arrow
        if (buoy.swellDir == null) {
            useCircle = true;
        }
        // value = `${buoy.period}sec ${buoy.height}ft`;
    }

    if (mapMode === "wind") {
        const size = sizeGust(buoy.windGust);
        width = height = size;
        angle = cardinalToDegrees(buoy.windDir);
        color1 = colorWspd(buoy.windSpeed);
        color2 = colorWspd(buoy.windGust);
        opacity = windOpacity(buoy.windGust);
        // value = `${"buoy.windSpeed"} `;
    }

    if (mapMode === "temperature") {
        const size = 20; //sizeGust(buoy.windGust);
        width = height = size;
        angle = 90; //cardinalToDegrees(buoy.windDir);
        color1 = colorTemp(buoy.airTemp);
        color2 = colorTemp(buoy.waterTemp);
        //doesn't really need opacity
        // opacity = waterTempOpacity(buoy.waterTemp);
        // Use circle for temperature (no directional meaning)
        useCircle = true;
        // value = `${buoy.airTemp || buoy.waterTemp} `;
    }

    if (mapMode === "pressure") {
        debugger;
        const size = 20; //sizeGust(buoy.windGust);
        width = height = size;
        angle = 0; //cardinalToDegrees(buoy.windDir);
        color1 = colorPressure(buoy.pressure);
        color2 = colorPressureTendency(buoy.pressureTendency);
        // value = `${buoy.pressure || buoy.pressureTendency} `;
    }

    if (mapMode === "visibility") {
        const size = 20; //sizeGust(buoy.windGust);
        width = height = size;
        angle = 0; //cardinalToDegrees(buoy.windDir);
        color1 = visibilityColor(buoy.visibility);
        color2 = visibilityColor(buoy.visibility);
        // value = `${buoy.visibility} `;
    }

    if (mapMode === "salinity") {
        const size = 20; //sizeGust(buoy.windGust);
        width = height = size;
        angle = 0; //cardinalToDegrees(buoy.windDir);
        color1 = colorSalinity(buoy.salinity);
        color2 = colorSalinity(buoy.salinity);
        // value = `${buoy.salinity} `;
    }

    const styles = useStyles({ width, height });

    let date = new Date(buoy.GMT).toLocaleString();
    // console.log(date);
    const MemoMarker = useMemo(() => {
        const IconComponent = useCircle ? CircleIcon : BuoyIcon;
        return (
            <Marker latitude={latitude} longitude={longitude} offsetLeft={width * -0.5} offsetTop={height * -0.5} onClick={() => onClick(true)}>
                {/* <Surfer /> */}
                <IconComponent
                    sx={{
                        fill: `url(#buoyLinearColors${buoy.stationId})`,
                        transform: `rotate(${angle}deg)`,
                        stroke: "#666",
                        strokeWidth: 0.6,
                        opacity: opacity,
                    }}
                    className={styles.iconStyle}
                />
                <svg width={0} height={0}>
                    <linearGradient id={`buoyLinearColors${buoy.stationId}`} x1={0} y1={0} x2={1} y2={1}>
                        <stop offset={0} stopColor={color1} />
                        <stop offset={1} stopColor={color2} />
                    </linearGradient>
                </svg>
            </Marker>
        );
    }, [latitude, longitude, angle, width, useCircle]);

    return MemoMarker;
}

export default BuoyMarker;
